'use strict';

class CollectionSend {
  constructor($location, $routeParams, invoiceService, originatorService, salesLedgerService) {
    this.$location = $location;
    this.invoiceService = invoiceService;
    this.originatorService = originatorService;
    this.salesLedgerService = salesLedgerService;

    this.number = $routeParams.number;
  }

  $onInit() {
    this.invoice = {};
    this.invoiceBalance = 0;
    this.creditor = {
      name: null,
      email: null,
      city: null,
      phone: null,
      description: null,
      organisationNumber: null,
      includeTax: false,
      acceptEula: false,
      collectionAgency: 'LINDORFF'
    };
    this.registered = false;
    // this.agencies = [];

    this.load();
  }

  load() {
    this.invoiceService.get(this.number)
      .then((resp) => {
        this.invoice = resp.data;
        this.creditor.organisationNumber = resp.data.originator.organisationNumber;

        this.originatorService.getCreditors()
          .then((creditors) => {
            if (creditors.data && creditors.data.length) {
              creditors.data.forEach((item) => {
                if (item.organisationNumber === this.invoice.originator.organisationNumber) {
                  if (item.collectionAgency === 'LINDORFF') {
                    this.registered = true;
                  }
                  // this.agencies.push(item.collectionAgency);
                  //
                  // if (this.agency === item.collectionAgency) {
                  //   this.creditor.collectionAgency = this.agency;
                  // }
                }
              });
            }
          });
      });

    this.salesLedgerService.getInvoiceBalance(this.number)
      .then((balance) => {
        this.invoiceBalance = balance.data.balance;
      });
  }

  register() {
    this.invoiceService.registerCreditor(this.creditor)
      .then(() => this.load());
  }

  send() {
    this.invoiceService.sendToDebtCollection(this.number)
      .then(() => this.$location.path(`/regning/${this.number}`));
  }
}

CollectionSend.$inject = ['$location', '$routeParams', 'invoiceService', 'originatorService', 'salesLedgerService'];

const collectionSend = {
  bindings: {
    prices: '<',
    originator: '<',
    agency: '<'
  },
  controller: CollectionSend,
  template: `
    <div class="row" ng-form="sendToDebtCollectionForm">

      <div class="large-9 columns">
        <h2>Send til inkasso</h2>
      </div>

      <div class="large-3 columns">
        <img ng-show="$ctrl.creditor.collectionAgency === 'LINDORFF'" alt="INTRUM" ng-src="/assets/img/intrum.png">
      </div>

      <div class="large-9 columns">
        <div ng-hide="$ctrl.registered">
          <p>SendRegning har integrert seg med Intrum for håndtering av inkassosaker.<br>Før du kan sende regningen din til inkasso må du inngå en avtale med Intrum.</p>

          <fieldset>
            <div>
              <label for="name">Navn på kontaktperson</label>
              <input type="text" id="name" name="name" ng-model="$ctrl.creditor.name" ng-required="!$ctrl.registered">
            </div>

            <div>
              <label for="email">E-postadresse</label>
              <input type="email" id="email" name="email" ng-model="$ctrl.creditor.email" maxlength="64" placeholder="ola@nordmann.no" ng-required="!$ctrl.registered">
            </div>

            <div>
              <label for="phone">Telefon</label>
              <input type="tel" id="phone" name="phone" ng-model="$ctrl.creditor.phone" ng-required="!$ctrl.registered">
            </div>

            <div ng-show="$ctrl.creditor.collectionAgency === 'LINDORFF'">
              <label for="city">By</label>
              <input type="text" id="city" name="city" ng-model="$ctrl.creditor.city" ng-required="!$ctrl.registered && $ctrl.creditor.collectionAgency === 'LINDORFF'">
            </div>

            <div ng-show="$ctrl.creditor.collectionAgency === 'LINDORFF'">
              <label for="description">Beskriv varen/tjenesten firmaet ditt hovedsakelig selger</label>
              <textarea id="description" name="description" ng-model="$ctrl.creditor.description" ng-required="!ctrl.registered && $ctrl.creditor.collectionAgency === 'LINDORFF'"></textarea>
            </div>

            <div>
              <label for="includeTax">
                <input type="checkbox" id="includeTax" name="includeTax" ng-model="$ctrl.creditor.includeTax">
                Er varene/tjenestene firmaet ditt hovedsakelig selger MVA-pliktige?
              </label>
            </div>

            <div >
              <label for="acceptEula" ng-show="$ctrl.creditor.collectionAgency === 'LINDORFF'">
                <input type="checkbox" id="acceptEula" name="acceptEula" ng-model="$ctrl.creditor.acceptEula" ng-required="!$ctrl.registered && $ctrl.creditor.collectionAgency === 'LINDORFF'">
                Jeg godtar <a href="https://www.sendregning.no/files/vilklar_intrum.pdf" target="_blank" rel="nofollow">vilkårene for bruk</a>
              </label>
            </div>
          </fieldset>
        </div>

        <div ng-show="$ctrl.registered">
          <fieldset>
            <h3 class="subheader">Informasjon</h3>
            <p>
              Fakturanummer: <b>{{ $ctrl.number }}</b><br>
              Fakturasum: <b>{{ $ctrl.invoice.total | crowns:false }} {{ $ctrl.invoice.currency }}</b><br>
              Utestående beløp: <b>{{ $ctrl.invoiceBalance | crowns:false }} {{ $ctrl.invoice.currency }}</b>
            </p>
          </fieldset>

          <fieldset>
            <h3 class="subheader">Mottager</h3>
            <p>
              <b>{{ $ctrl.invoice.recipient.name }}</b><br>
              {{ $ctrl.invoice.recipient.address.address1 }}<br>
              {{ $ctrl.invoice.recipient.address.address2 }}<br>
              {{ $ctrl.invoice.recipient.address.zip }} {{ $ctrl.invoice.recipient.address.city }}<br>
              {{ $ctrl.invoice.recipient.address.country }}
            </p>
          </fieldset>

          <fieldset>
            <h3 class="subheader" ng-show="$ctrl.agency === 'LINDORFF'">Pris eks. MVA</h3>

            <p ng-show="$ctrl.agency === 'LINDORFF'">Overføre en regning til INTRUM for inkasso <b>{{ $ctrl.prices.collection | crowns:false }} {{ $ctrl.invoice.currency }}</b></p>

            <p ng-show="$ctrl.agency === 'LINDORFF'">I tillegg kommer kostnader for Intrums tjenester - <a href="https://www.sendregning.no/files/Priser_Intrum.pdf" target="_blank" rel="nofollow">se fullstendig prisliste</a></p>

            <p ng-show="$ctrl.agency === 'LINDORFF'"><b>NB!</b> Regninger som mottager har meldt en innsigelse mot kan ikke sendes via SendRegning, vennligst kontakt <a href="mailto:hjelp@intrum.com">INTRUM</a> direkte.</p>


          </fieldset>
        </div>
      </div>

      <div class="large-3 columns">
        <p>
          <a ng-href="{{ $ctrl.invoice.publicPdfUrl }}">
            <jpg type="'invoice'" number="$ctrl.number" />
          </a>
        </p>

        <button ng-click="$ctrl.register()" class="button large expand" ng-hide="$ctrl.registered" ng-disabled="sendToDebtCollectionForm.$invalid">Inngå avtale</button>
        <button ng-click="$ctrl.send()" class="button large expand" ng-show="$ctrl.registered">Send til inkasso</button>
        <a role="button" href="#/regning/{{ $ctrl.number }}" class="button secondary expand">Avbryt</a>
      </div>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('collectionSend', collectionSend)
  .config(($routeProvider) => {
    $routeProvider
      .when('/inkasso/:number/send', {
        title: 'Send til inkasso',
        template: '<collection-send prices="$resolve.prices" agency="$resolve.agency" />',
        resolve: {
          prices: (commonService) => commonService.getPrices(),
          agency: (originatorService) => originatorService.settings().then((resp) => resp.data.defaults.collectionAgency)
        },
        noSidebar: true,
        overlay: true,
        secure: true
      });
  });
